import { required, maxLength, email, minLength, sameAs } from 'vuelidate/lib/validators'

const senhaForte = value => {
  if (typeof value === 'undefined' || value === null || value === '') {
    return true
  }
  return /[a-z]/.test(value) && /[A-Z]/.test(value) && /[0-9]/.test(value)
}
const regexUsuario = value => {
  if (typeof value === 'undefined' || value === null || value === '') {
    return true
  }
  return /^[a-zA-Z0-9.]*$/g.test(value) // eslint-disable-line
}

export const validateData = {
  form: {
    role: { required },
    name: { required, maxLength: maxLength(30), regexUsuario },
    email: { required, email },
    password: { required, minLength: minLength(6), senhaForte },
    password_confirmation: { sameAsSenha: sameAs('password') },
  },
}

export const validateComputed = {
  roleErrors() {
    const errors = []
    if (!this.$v.form.role.$dirty) return errors
    !this.$v.form.role.required && errors.push('Perfil é obrigatório.')
    return errors
  },
  nameErrors() {
    const errors = []
    if (!this.$v.form.name.$dirty) return errors
    !this.$v.form.name.maxLength && errors.push('Usuário não pode ter mais de 10 dígitos')
    !this.$v.form.name.required && errors.push('Usuário é obrigatório.')
    !this.$v.form.name.regexUsuario && errors.push('Apenas letras, números e ponto são permitidos.')
    return errors
  },
  emailErrors() {
    const errors = []
    if (!this.$v.form.email.$dirty) return errors
    !this.$v.form.email.required && errors.push('Email é obrigatório.')
    !this.$v.form.email.email && errors.push('Favor inserir um email no formato correto.')
    return errors
  },
  passwordErrors() {
    const errors = []
    if (!this.$v.form.password.$dirty) return errors
    if(!(this.edicao == 'true')){
      !this.$v.form.password.required && errors.push('Senha é obrigatória.')
    }
    !this.$v.form.password.minLength && errors.push('Senha deve conter ao menos 6 caracteres.')
    !this.$v.form.password.senhaForte &&
      errors.push('Senha deve conter ao menos uma letra maiúscula, uma minúscla e um número.')
    return errors
  },
  password_confirmationErrors() {
    const errors = []
    if (!this.$v.form.password_confirmation.$dirty) return errors
    !this.$v.form.password_confirmation.sameAsSenha && errors.push('Senhas não são compatíveis.')
    return errors
  },
}
